import { useSelector } from 'react-redux';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { isDomainFolder, isMountedFolder } from 'reactApp/modules/storage/folder.helpers';
import { STORAGE_CONFIG } from 'reactApp/modules/storage/storage.config.new';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import {
    getStorageCurrentFolder,
    getStorageSelectedItems,
    hasParentMountedOrSharedFolder,
    isMountedOrSharedFolder,
} from 'reactApp/modules/storage/storage.selectors';
import type { CloudItem } from 'reactApp/modules/storage/storage.types';
import type { RootState } from 'reactApp/store';

/**
 * Определяем можно ли расшарить на список пользователей текущий или выбранный элемент.
 */
export const useShowShare = () => {
    const currentStorage = useSelector(getCurrentStorage);

    let canShare = Boolean(STORAGE_CONFIG[currentStorage]?.share);
    const selected = useSelector((state: RootState) => getStorageSelectedItems(state, currentStorage)) as CloudItem[];
    const currentFolder = useSelector((state: RootState) => getStorageCurrentFolder(state, currentStorage));
    const isMountedOrSharedFolderStatus = useSelector((state: RootState) => isMountedOrSharedFolder(state, currentFolder));
    const hasParentMountedOrShared = useSelector((state: RootState) => hasParentMountedOrSharedFolder(state, selected));

    if (canShare) {
        const { isHome, isSharedLinks, isSharedIncoming, isSearch } = getStorage(currentStorage);

        const selectedCount = selected.length;
        const isOneItemFolder = selectedCount === 1 && selected[0].isFolder;
        const isNotRootFolder = Boolean(currentFolder) && currentFolder?.id !== ROOT_FOLDER_ID;
        const itemsWithDomain = selected.length ? selected.some(isDomainFolder) : currentFolder && isDomainFolder(currentFolder);
        const isCurrentSharedOrMounted = isMountedOrSharedFolderStatus.is;
        const isSelectedMounted = selected.some(isMountedFolder);

        canShare = isOneItemFolder;

        if (isHome && isNotRootFolder) {
            canShare =
                !itemsWithDomain &&
                (isCurrentSharedOrMounted
                    ? // нельзя "Настроить доступ" у подпапок примонтированной папки
                      !selectedCount && isMountedOrSharedFolderStatus.folderId === currentFolder?.id
                    : !selectedCount || isOneItemFolder);
        } else if (isSharedLinks) {
            canShare = isOneItemFolder;
        } else if (isSharedIncoming) {
            canShare = isOneItemFolder && isSelectedMounted;
        } else if (isSearch) {
            canShare = !hasParentMountedOrShared && isOneItemFolder;
        }
    }

    return canShare;
};
